import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getPerfis, getPerfilById, postPerfil } from "@/services/perfil";
import { Button as AntdButton, message } from "antd";
import { Input } from "@/components/ui/inputForm";
import { Table, Switch, Space, ConfigProvider, theme } from "antd";
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { usePermissions } from "@/hooks/usePermissions";
import { Container } from "./styles";

export default function ConsultaPerfil() {
  const [perfis, setPerfis] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const { canInsert, canEdit } = usePermissions();

  useEffect(() => {
    handleGetPerfis();
  }, []);
  
  const handleGetPerfis = async () => {
    try {
      const { data } = await getPerfis();
      setPerfis(data.map((p: any) => ({ ...p, ativo: p.ativo ?? true })));
    } catch (error) {
      message.error("Erro ao carregar perfis.");
    }
  };

  const handleAdd = useCallback(() => {
    navigate("/perfil/cadastro");
  }, [navigate]);

  const handleEdit = (id: string) => {
    navigate(`/perfil/${id}`);
  };

  const toggleAtivo = async (id: string) => {
    try {
      const { data: perfil } = await getPerfilById(id);
      const updatedPerfil = { ...perfil, ativo: !perfil.ativo };
      const response = await postPerfil(updatedPerfil);
      
      if (response.status === 200 || response.status === 201) {
        setPerfis((prev) =>
          prev.map((p) => (p.id === id ? { ...p, ativo: !p.ativo } : p))
        );
        message.success(`Perfil ${!perfil.ativo ? 'ativado' : 'inativado'} com sucesso!`);
      } else {
        message.error("Falha ao atualizar o status.");
      }
    } catch (error) {
      message.error("Erro ao comunicar com o servidor.");
    }
  };

  const columns = [
    { title: "Nome", dataIndex: "nome", key: "nome" },
    {
      title: "Status",
      dataIndex: "ativo",
      key: "ativo",
      render: (value: boolean, record: any) => (
        <Switch 
          checked={!!value} 
          onChange={() => toggleAtivo(record.id)} 
          checkedChildren="Ativo" 
          unCheckedChildren="Inativo"
        />
      ),
    },
    {
      title: "Ação",
      key: "acao",
      render: (_: any, record: any) => (
        <Space size="middle">
          {canEdit(14) && (
            <AntdButton type="text" icon={<EditOutlined />} onClick={() => handleEdit(record.id)} />
          )}
        </Space>
      ),
    },
  ];

  const filteredPerfis = perfis.filter((p) =>
    p.nome?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div className="mb-8">
        <span className="text-white text-2xl">Consulta de Perfis</span>
      </div>
      <ConfigProvider theme={{ algorithm: [theme.compactAlgorithm, theme.darkAlgorithm] }}>
        <Container>
          <div className="flex gap-8 items-end mb-8">
            <Input
              type="text"
              placeholder="Pesquisar por nome"
              className="w-80"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {canInsert(14) && (
              <AntdButton className="flex gap-2" onClick={handleAdd}>
                Novo
                <PlusOutlined />
              </AntdButton>
            )}
          </div>
          <div className="grid">
            <div>
              <Table columns={columns} dataSource={filteredPerfis} rowKey="id" />
            </div>
          </div>
        </Container>
      </ConfigProvider>
    </>
  );
} 